import { DATE_PIPE_DEFAULT_OPTIONS, formatDate } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DateModel } from './date.model';


@Pipe({
    name: 'dateModel',
})
export class DateModelPipe implements PipeTransform {

    private locale = inject(LOCALE_ID);

    private config = inject(DATE_PIPE_DEFAULT_OPTIONS, { optional: true });

    transform(value: DateModel, format = 'mediumDate', timezone?: string, locale?: string) {
        const date = new Date(value.year, value.month, value.day);
        return formatDate(date, format, locale || this.locale, timezone ?? this.config?.timezone);
    }
}
